import '../css/main.css';
import './legacyEngine';

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.swiper')) {
    void import('swiper/css' as string);
    void import('swiper/css/autoplay' as string);
    void import('swiper/css/a11y' as string);
  }

  if (document.querySelector('.partners-slider')) {
    (async () => {
      const { PartnerSlider } = await import('./sliders/PartnerSlider');
      new PartnerSlider();
    })();
  }

  if (document.querySelector('.about-us-slider')) {
    (async () => {
      const { AboutSlider } = await import('./sliders/AboutSlider');
      new AboutSlider();
    })();
  }

  if (document.querySelector('.front-page-slider')) {
    (async () => {
      const { FrontPageSlider } = await import('./sliders/FrontPageSlider');
      new FrontPageSlider();
    })();
  }

  if (document.querySelector('[data-bg-target]')) {
    (async () => {
      const { BackgroundSwitcher } = await import('./BackgroundSwitcher');
      new BackgroundSwitcher();
    })();
  }

  if (document.body.classList.contains('single')) {
    (async () => {
      const { Counter } = await import('./Counter');
      const counter = new Counter();
      counter.incrementPostViews();
    })();
  }

  if (document.querySelector('.ad-container')) {
    (async () => {
      const { AdManager } = await import('./AdManager');
      new AdManager().init();
      void import('../scss/advert.scss' as string);
    })();
  }
});

